
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class DataQualityWorkflowDialog extends SiteEntityDialog<WorkflowRow, any> {
        protected getFormKey() { return DataQualityWorkflowForm.formKey; }
        protected getIdProperty() { return WorkflowRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowRow.localTextPrefix; }
        protected getNameProperty() { return WorkflowRow.nameProperty; }
        protected getService() { return WorkflowService.baseUrl; }
        protected getEntityTitle() { return "Data Quality Workflow"; }

        protected form = new WorkflowForm(this.idPrefix);

    }
}